/* === Accord d'un compte, partagé par tous les produits d'export === */

/** « 1 note » / « 3 notes » : accord d'un compte pour les récapitulatifs et rapports d'export. */
export const plural = (count: number, singular: string, plural_: string): string =>
    `${count} ${count > 1 ? plural_ : singular}`;
